import React from "react";

/**
 * Full-screen preloader — original block animation (four rotating squares).
 */
const PageLoader = () => (
  <div className="preloader">
    <div className="loader">
      <span />
      <span />
      <span />
      <span />
    </div>
  </div>
);

export default PageLoader;
